// extracted by mini-css-extract-plugin
export default {"content":"Content_content__IWOZY","grid":"Content_grid__2XPWH"};